import { render, staticRenderFns } from "./ActivityPanel.vue?vue&type=template&id=619bd0e3&scoped=true"
import script from "./ActivityPanel.vue?vue&type=script&lang=js"
export * from "./ActivityPanel.vue?vue&type=script&lang=js"
import style0 from "./ActivityPanel.vue?vue&type=style&index=0&id=619bd0e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619bd0e3",
  null
  
)

export default component.exports